import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from '../../components/generalForm';
import { connect } from 'react-redux';
import RichText from '../../components/customFields/richText';
import PackerDeliveryOrderBatchRefundItem from './packerDeliveryOrderBatchRefundItem';

const PackerRefundForm = ({
  intl,
  refundOrderItems,
  orderBatchId,
  user,
  closeModal,
  updateRefundOrderItem,
  removeRefundOrderItemFromIndex,
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refundProperties, setRefundProperties] = useState({});

  useEffect(() => {
    setError(null);
    setLoading(true);
    apiCalls
      .getUsersAdmin({
        userId: user.id,
      })
      .then((result) => {
        setLoading(false);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, []);

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      email: {
        title: intl.formatMessage({ id: 'email.form.title' }),
        type: 'object',
        required: [],
        properties: {
          subject: {
            type: 'string',
            title: intl.formatMessage({ id: 'email.form.field.subject.label' }),
            default: intl.formatMessage({ id: 'email.form.packer.refund.subject' }, { orderBatchId }),
          },
          body: {
            type: 'string',
            title: intl.formatMessage({ id: 'email.form.field.body.label' }),
            default: '',
          },
          to: {
            type: 'string',
            title: intl.formatMessage({ id: 'email.form.field.to.label' }),
            default: '',
          },
        },
      },
    },
  };

  if (!refundProperties.includeEmail) {
    delete formSchema.properties.email;
  }

  const uiSchema = {
    email: {
      body: {
        'ui:field': 'richText',
      },
    },
  };

  function onFormSubmit() {
    const groupedRefunds = utils.groupBy(refundOrderItems, 'orderId');
    const paymentRefunds = Object.keys(groupedRefunds).map((orderId) => ({
      orderId,
      amount: groupedRefunds[orderId]
        .reduce((result, roi) => {
          return result + roi.amount;
        }, 0)
        .toString(),
      comment: groupedRefunds[orderId].map((roi) => getRefundOrderItemCopy(roi)).join(';\n '),
      payer: groupedRefunds[orderId][0].payer,
    }));

    setLoading(true);

    apiCalls
      .createPaymentRefund({
        ...refundProperties,
        paymentRefunds,
      })
      .then((result) => {
        setLoading(false);
        const successCopy = result.data.email
          ? 'payment.refund.form.create.success.alert.with.email'
          : 'payment.refund.form.create.success.alert.no.email';

        alert(intl.formatMessage({ id: successCopy }));
        closeModal();
      })
      .catch((error) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(error, true));
        window.scrollTo(0, 0);
      });
  }

  const buttonCopy = 'refund.create.form.submit';

  const formFields = {
    richText: RichText,
  };

  return (
    <div className="row">
      <div className="col-12 admin__form">
        <div className="m-b-1">
          {refundOrderItems.map((roi, index) => {
            return (
              <PackerDeliveryOrderBatchRefundItem
                key={index}
                updateRefundOrderItem={(newRoi) => updateRefundOrderItem(newRoi, index)}
                removeRefundOrderItem={() => removeRefundOrderItemFromIndex(index)}
                refundOrderItem={roi}
              />
            );
          })}
        </div>
        <div className="m-b-3">
          <FormattedMessage id={'packer.refund.form.total'} />:{' '}
          <strong className="text-h3">
            {utils.getRoundedPrice(
              refundOrderItems.reduce((result, roi) => {
                return result + roi.amount;
              }, 0)
            )}
            €
          </strong>
        </div>

        <GeneralForm
          onChange={(event) => setRefundProperties(event.formData)}
          onSubmit={onFormSubmit}
          formSchema={formSchema}
          formUiSchema={uiSchema}
          formFields={formFields}
          formData={refundProperties}
          buttonCopy={buttonCopy}
          errorMessage={error}
          loading={loading}
          hideImageUpload={true}
        />
      </div>
    </div>
  );
};

function getRefundOrderItemCopy(roi) {
  return `${roi.orderItem.itemName} - ${roi.amount}€${
    roi.amount !== roi.orderItem.itemPrice ? ` / ${roi.orderItem.itemPrice}€` : ''
  }`;
}

PackerRefundForm.propTypes = {
  refundOrderItems: PropTypes.array.isRequired,
  orderBatchId: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  updateRefundOrderItem: PropTypes.func.isRequired,
  removeRefundOrderItemFromIndex: PropTypes.func.isRequired,
};

PackerRefundForm.defaultProps = {};

function mapStateToProps(state) {
  return {};
}

export default injectIntl(connect(mapStateToProps)(PackerRefundForm));
